<template>
  <div class="bg-gray p-2 border-main-container">
    <div class="bg-white p-3 rounded pl-c-xl">
      <div class="mr-4 ml-4">
        <icon-view
          class="mr-2 mt-1 rounded-circle icon-view-color-text"
          icon="fas fa-user-tag mb-1 fa-xs"
          icon-background="white"
          icon-color="#FF7058"
          icon-size="16px"
          title="Añadir Pariente"
          v-if="!isEditable"
        />
        <icon-view
          v-if="isEditable"
          class="mr-2 mt-1 rounded-circle icon-view-color-text"
          icon="fas fa-edit"
          icon-background="white"
          icon-color="#2DB782"
          icon-size="16px"
          title="Editar Pariente"
        />
        <validation-observer ref="parientInfoForm" v-slot="{}" tag="form">
          <div class="row mt-1">
            <div class="col-md-4 mb-3">
              <span class="data-title d-block mb-2">Nombre del Pariente:</span>
              <validation-provider
                v-slot="{ errors }"
                name="validationCustomParentName"
                rules="required"
              >
                <CustomInput
                  id="CustomInputParentName"
                  v-model="parentName"
                  custom-error-msg="El nombre del pariente es requerido."
                  :error="errors[0]"
                />
              </validation-provider>
            </div>
            <div class="col-md-4">
              <span class="data-title d-block mb-2">Apellidos:</span>
              <validation-provider
                v-slot="{ errors }"
                name="validationCustomSurname"
                rules="required"
              >
                <CustomInput
                  id="CustomParentSurname"
                  v-model="parentSurname"
                  custom-error-msg="El(los) apellido(s) es(son) requerido(s)."
                  :error="errors[0]"
                />
              </validation-provider>
            </div>
            <div class="col-md-4">
              <span class="data-title d-block mb-2">Parentesco:</span>
              <validation-provider
                v-slot="{ errors }"
                name="validationCustomRelationship"
                rules="required"
              >
                <CustomDropDown
                  id="customDropRelationship"
                  v-model="parentRelationship"
                  fieldkey="id"
                  fieldname="name"
                  placeholder="Seleccione"
                  custom-error-msg="El parentesco es requerido."
                  :error="errors[0]"
                  :options="optionsRelationships"
                />
              </validation-provider>
            </div>
            <div class="col-md-4 mb-3">
              <span class="data-title d-block mb-2">Correo Electrónico:</span>
              <validation-provider
                v-slot="{ errors }"
                name="validationCustomtEmail"
                rules="required|email"
                mode="passive"
                :custom-messages="{
                  email: 'El correo electrónico no es válido.',
                  required: 'El correo electrónico es requerido.',
                }"
              >
                <CustomInput
                  id="CustomInputParentEmail"
                  v-model="parentEmail"
                  type="email"
                  :error="errors[0]"
                  :custom-error-msg="errors[0]"
                />
              </validation-provider>
            </div>
            <div class="col-md-4">
              <span class="data-title d-block mb-2">Teléfono 1:</span>
              <validation-provider
                v-slot="{ errors }"
                name="validationCustomtPhone1"
                rules="required|completePhone"
              >
                <CustomInput
                  id="CustomInputPhone1"
                  custom-error-msg="El teléfono es requerido."
                  :error="errors[0]"
                  v-model="parentPhone1"
                  :mask-type="'Phone'"
                  placeholder="(___) ___-____"
                />
              </validation-provider>
            </div>
            <div class="col-md-4">
              <span class="data-title d-block mb-2">Teléfono 2:</span>
              <CustomInput
                id="CustomInputPhone2"
                v-model="parentPhone2"
                :mask-type="'Phone'"
                placeholder="(___) ___-____"
              />
            </div>
          </div>
        </validation-observer>
        <div class="row mt-1">
          <div class="col-md-12 text-right">
            <ActionButton
              i="fas fa-times-circle"
              variant="outline-danger m-2"
              text="Cancelar"
              @click="cancel()"
            />
            <ActionButton
              i="fas fa-save"
              variant="success mt-2 ml-2 mb-2"
              text="Guardar"
              @click="saveParent()"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import PageHeader from "PageHeader";
import IconView from "icon-view";
import CustomInput from "@/components/common/CustomInput";
import CustomDatePicker from "custom-date-picker";
import CustomDropDown from "@/components/common/CustomDropDown";
import StudentServices from "@/services/pc/referral-student";
import Callout from "custom-callout";
import ActionButton from "@/components/common/ActionButton";
export default {
  name: "ParentInformation",
  components: {
    PageHeader,
    IconView,
    CustomInput,
    CustomDatePicker,
    Callout,
    CustomDropDown,
    ActionButton,
  },
  props: {
    optionsRelationships: {
      type: Array,
      required: true,
    },
    dto: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      parentName: null,
      parentSurname: null,
      parentRelationship: null,
      parentEmail: null,
      parentPhone1: null,
      parentPhone2: null,
    };
  },
  mounted() {
    if (this.dto != null) {
      this.parentName = this.dto.name;
      this.parentSurname = this.dto.surname;
      this.parentRelationship = this.getRelationShipById(
        this.dto.relationshipId
      );
      this.parentEmail = this.dto.email;
      this.parentPhone1 = this.dto.phone1;
      this.parentPhone2 = this.dto.phone2;
    }
  },
  computed: {
    isEditable() {
      return this.dto != null;
    },
  },
  methods: {
    cancel() {
      this.$emit("cancel");
    },
    async saveParent() {
      const isValid = await this.$refs.parientInfoForm.validate();
      if (isValid) {
        var model = {
          name: this.parentName,
          surname: this.parentSurname,
          peiCodeRelationshipId: this.parentRelationship.id,
          email: this.parentEmail,
          phone1: this.parentPhone1,
          phone2: this.parentPhone2,
        };
        if (this.dto != null) {
          model = {
            ...model,
            id: this.dto.id,
          };
        }
        this.$emit("save", model);
      }
    },
    getData() {},
    getRelationShipById(id) {
      return this.optionsRelationships.find((x) => x.id === id);
    },
    getEthnicityById(id) {
      return this.optionsEthnicities.find((x) => x.id === id);
    },
    getGenderById(id) {
      return this.optionsGender.find((x) => x.id === id);
    },
    async getDataSelect() {
      await StudentServices.getStudentSelect().then(({ data }) => {
        const dataRoute = data;
        this.optionsEthnicities = dataRoute.ethnicities;
        this.optionsGender = dataRoute.genders;
        this.optionsRelationships = dataRoute.relationships;
        this.optionsMunicipalities = dataRoute.municipalities;
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.center {
  margin-left: 6px;
  margin-top: 7px;
}
.phone-icon {
  display: inline-block;
  font-size: 20px;
  line-height: 35px;
  background-color: #ff7058;
  color: white;
  width: 35px;
  height: 35px;
  border-radius: 50%;
  text-align: center;
  vertical-align: bottom;
}
.edit-icon {
  display: inline-block;
  font-size: 20px;
  line-height: 35px;
  background-color: #2eb882;
  color: white;
  width: 35px;
  height: 35px;
  border-radius: 15%;
  text-align: center;
  vertical-align: bottom;
}
.edit-icon:hover {
  background-color: #2b9d71;
}
.border-main-container {
  border-radius: 5px;
}
</style>
